import { Link } from 'react-router-dom';
import { ANDROID_STORES } from '../../storeLinks.js';
import { WebAppLink } from '../WebAppCta';

const Footer = () => (
    <footer className="site-footer">
        <div className="site-container footer-grid">
            <div className="footer-brand">
                <img src="/hooshpaz-logo.webp" alt="نشان هوش‌پز" width="512" height="512" />
                <div>
                    <strong>هوش‌پز</strong>
                    <p>دستیار آشپزی هوشمند فارسی؛ از مواد اولیه‌ای که داری، یک دستور پخت کامل بساز.</p>
                </div>
            </div>
            <div className="footer-links">
                <a href="/#features">امکانات</a>
                <a href="/#how-it-works">نحوه کار</a>
                <Link to="/recipes">کتاب آشپزی</Link>
                <Link to="/about">درباره هوش‌پز</Link>
                <Link to="/faq">سوالات متداول</Link>
                <Link to="/privacy">حریم خصوصی</Link>
                <Link to="/terms">شرایط استفاده</Link>
                <Link to="/contact">تماس با ما</Link>
            </div>
        </div>
        <div className="site-container footer-stores">
            <div className="footer-store-group">
                <span>دریافت اپلیکیشن اندروید:</span>
                {ANDROID_STORES.map((store) => (
                    <a key={store.id} href={store.url} target="_blank" rel="noreferrer">هوش‌پز در {store.name}</a>
                ))}
            </div>
            <div className="footer-store-group">
                <span>آیفون و بدون نصب:</span>
                <WebAppLink link="footer">نسخه وب هوش‌پز (app.hooshpaz.ir)</WebAppLink>
            </div>
        </div>
        <p className="site-container footer-official">اپلیکیشن رسمی هوش‌پز با شناسه <bdi dir="ltr">ir.hooshpaz.hooshpaz</bdi> در استورهای ایرانی منتشر شده است.</p>
        <div className="site-container footer-bottom">
            <span>© ۱۴۰۵ هوش‌پز</span>
            {/* Spelled out the way people search for it: the design uses a ZWNJ, readers type a
                space or nothing at all, and search engines index those as different strings. */}
            <span>هوش‌پز، هوش پز، هوشپز | ساخته‌شده برای آشپزی ساده‌تر و دورریز کمتر</span>
        </div>
        <div className="site-container footer-trust">
            {/* eNamad trust seal: markup kept as issued (referrer policy + `code` attribute),
                because the seal validates the embedding page from them. `noreferrer` would strip
                that Referer, so only `noopener` is set. */}
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
                referrerPolicy="origin"
                target="_blank"
                rel="noopener"
                href="https://trustseal.enamad.ir/?id=7723064&Code=mHy7TeTkjKdeKNLJAw1kWKR5hkKmkpl4"
            >
                <img
                    referrerPolicy="origin"
                    src="https://trustseal.enamad.ir/logo.aspx?id=7723064&Code=mHy7TeTkjKdeKNLJAw1kWKR5hkKmkpl4"
                    alt="نماد اعتماد الکترونیکی"
                    style={{ cursor: 'pointer' }}
                    code="mHy7TeTkjKdeKNLJAw1kWKR5hkKmkpl4"
                />
            </a>
        </div>
    </footer>
);

export default Footer;
